var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1067.566,
    height: 1459,
    viewBox: "-10 0 1067.566 1459"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M213.899 786h1q-46-79-57-169.5t11-173 76.5-155.5 134.5-119 170-57 173 11 155.5 77 118.5 134.5 57 170-11 173-77 155.5-134.5 119-170 56.5-173-11.5-155.5-76.5-119-134.5m347 448v-60q-150-11-280.5-91t-208.5-215q-61-107-76.5-228.5t13.5-233 101-210.5 177-163l11-6 18-10 30-17 37 65-29 17 21 37-36 21-21-37q-120 76-187 199t-66 264 73 265q53 92 137.5 156.5t181 92 201.5 18 200-59.5l-21-36 36-21 21 37 30-17 37 65-29 17-18 11-11 6q-125 69-267 75v59zm-54 60h183q37 29 113 51.5t134 30.5l58 8v75h-793v-75q9-1 24.5-3t58.5-10 80-17 78-25.5 64-34.5"
  })));
};
export default SvgMap;